import { render, staticRenderFns } from "./CreationOption.vue?vue&type=template&id=1e32274a&scoped=true&"
import script from "./CreationOption.vue?vue&type=script&lang=js&"
export * from "./CreationOption.vue?vue&type=script&lang=js&"
function injectStyles (context) {
  
  var style0 = require("./CreationOption.vue?vue&type=style&index=0&id=1e32274a&scoped=true&lang=scss&")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "1e32274a",
  null
  ,true
)

export default component.exports